export default __webpack_public_path__ + "static/media/11.7cd8c69f.png";